import { render, staticRenderFns } from "./buttonset.vue?vue&type=template&id=c5444f8e&scoped=true"
import script from "./buttonset.vue?vue&type=script&lang=js"
export * from "./buttonset.vue?vue&type=script&lang=js"
import style0 from "./buttonset.vue?vue&type=style&index=0&id=c5444f8e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c5444f8e",
  null
  
)

export default component.exports